const BRANDS_TABLE_READY = "brands-table-ready"
const SEARCH_TEXT_STATE = "brands-table-search-text-state"
const ROWS_PER_PAGE_STATE = "brands-table-rows-per-page-state"
const PAGINATION_STATE = "brands-table-pagination-state"

const BRAND_ID_FOR_ACTION = "brands-table-brand-id-for-action"

const ADD_EDIT_BRAND_READY = "add-edit-brand-ready"


const PREVIOUS_BRAND_FILTER_STATUS = "previous-brand-filter-status-action"

const PREVIOUS_BRAND_FILTER_GROUP_ID = "previous-brand-filter-group-id-action"



const initialState = {
    isBrandsTableReady: true,
    isAddEditBrandReady:true,
    brands: {},

    
    brandSelectedId: null,
    
    previousSearchText: "",
    previousRowsPerPageValue: 15,
    previousPaginationValue: 1,

    previousFilterStatus : "",
    previousFilterGroupId : "",
    
}


export default function reducer(state = initialState, action) {
    let duplicateState = null
    switch (action.type) {
        case BRANDS_TABLE_READY:
            return Object.assign({}, state, { isBrandsTableReady: action.payload })
        case ADD_EDIT_BRAND_READY:
            return Object.assign({}, state, { isAddEditBrandReady: action.payload })
        


        case SEARCH_TEXT_STATE :
            duplicateState = Object.assign({}, state)
            duplicateState.previousSearchText = action.payload
            return Object.assign({}, state, duplicateState)
        
        case ROWS_PER_PAGE_STATE:
            duplicateState=Object.assign({},state)
            duplicateState.previousRowsPerPageValue= action.payload
            return Object.assign({}, state, duplicateState)
        
        case PAGINATION_STATE:
            duplicateState= Object.assign({},state)
            duplicateState.previousPaginationValue = action.payload
            return Object.assign({}, state, duplicateState)

        case BRAND_ID_FOR_ACTION:
            return Object.assign({}, state, {brandSelectedId:action.payload})

        case PREVIOUS_BRAND_FILTER_STATUS:
            return Object.assign({}, state, {previousFilterStatus:action.payload})

        case PREVIOUS_BRAND_FILTER_GROUP_ID:
            return Object.assign({}, state, {previousFilterGroupId:action.payload})

        default:
        return state
    
    }

}

export function brandTableReady(data) {
    return {
        type: BRANDS_TABLE_READY,
        payload: data
    }
}


export function addEditBrandReady(data) {
    return {
        type: ADD_EDIT_BRAND_READY,
        payload: data
    }
}



export function searchTextState(searchText){
    return {
        type:SEARCH_TEXT_STATE,
        payload:searchText
    }
}

export function rowsPerPageState(rows){
    return {
        type:ROWS_PER_PAGE_STATE,
        payload:rows
    }
}

export function paginationState(pageNo){
    return{
        type:PAGINATION_STATE,
        payload:pageNo
    }
}

export function brandIdForAction(brandId){
    return{
        type:BRAND_ID_FOR_ACTION,
        payload:brandId
    }
}

export function previousFilterStatus(filterVal){
    return{
        type:PREVIOUS_BRAND_FILTER_STATUS,
        payload:filterVal
    }
}


export function previousFilterGroupId(filterVal){
    return{
        type:PREVIOUS_BRAND_FILTER_GROUP_ID,
        payload:filterVal
    }
}




// WEBPACK FOOTER //
// ./src/modules/Brands/redux/brands.js